const stColorToHex = {
  primary: {
    light: '#e5f3ff',
    dark: '#293056',
  },
  error: {
    light: '#fee4e2',
    dark: '#7a271a',
  },
  warning: {
    light: '#fef0c7',
    dark: '#7a2e0e',
  },
  success: {
    light: '#d1fadf',
    dark: '#054f31',
  },
  bluelight: {
    light: '#e0f2fe',
    dark: '#0b4a6f',
  },
  indigo: {
    light: '#e0eaff',
    dark: '#2d3282',
  },
  purple: {
    light: '#ebe9fe',
    dark: '#3e1c96',
  },
  pink: {
    light: '#fce7f6',
    dark: '#851651',
  },
  orange: {
    light: '#ffead5',
    dark: '#7e2410',
  },
  gray: {
    light: '#e4e7ec',
    dark: '#344054',
  },
} as const;

export default stColorToHex;
